import React from 'react';
import { useAddLanguageComponent } from './useAddLanguageComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import UploadIcon from '@mui/icons-material/CloudUploadOutlined';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddLanguage.styles';
import theme from '../../../../styles/theme';
import { ILanguage } from '../../../../types/interfaces/language';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import { uploadFilesUtils } from '../../../../utils/upload-files-utils';

interface IAddLanguageProps {
  language: ILanguage;
  onClose: () => void;
}

export default function AddLanguage(props: IAddLanguageProps) {
  const { language, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading, avatar, setAvatar } = useAddLanguageComponent(
    onClose,
    language,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <div className={classes.avatarWrapper}>
              <AppEntityAvatar
                fileBlob={avatar?.fileBlob}
                entity={language}
                size={AvatarSize.l}
                type={AvatarTypes.square}
              />
            </div>
            <AppButton
              variant="outlined"
              component="label"
              className={classes.uploadFileButton}>
              <input
                autoComplete="off"
                style={{ display: 'none' }}
                accept="image/png, image/jpeg"
                tabIndex={-1}
                type="file"
                onChange={(e) => {
                  uploadFilesUtils(e.target.files).then((uploadedFiles) => {
                    setAvatar(uploadedFiles[0]);
                  });
                }}
              />
              <UploadIcon />
              {t('common.avatar')}
            </AppButton>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.key')}
              fullWidth
              name="key"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.title')}
              fullWidth
              name="title"
              formik={formik}
            />
          </Grid>
          <Grid item sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="active"
                  checked={formik.values.active}
                  onChange={(e) =>
                    formik.setFieldValue('active', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.active')}
            />
          </Grid>
        </Grid>
        <Box className={classes.addLanguageButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {language ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
